<template>
  <div class="flex flex-column h-full overflow-hidden">
    <!-- Agregar nueva línea -->
    <div class="p-3 border-bottom-1 surface-border flex-none">
      <div class="text-sm font-medium mb-2">Nueva línea</div>
      <div class="flex gap-2 align-items-center">
        <input
          v-model="colorNueva"
          type="color"
          class="border-round flex-shrink-0"
          style="width:32px;height:32px;border:1px solid #ccc;padding:2px;cursor:pointer"
          title="Color de la línea"
        />
        <InputText
          v-model="nuevaLinea"
          placeholder="Nº línea (ej: 144)"
          class="flex-1"
          size="small"
          @keyup.enter="agregar"
        />
        <Button icon="pi pi-plus" size="small" @click="agregar" :disabled="!nuevaLinea.trim()" />
      </div>
    </div>

    <!-- Lista de líneas -->
    <div class="flex flex-column gap-1 p-2 overflow-auto" style="flex: 1 1 0">
      <TransporteLineaItem
        v-for="linea in lineas"
        :key="linea.id"
        :linea="linea"
        :activa="lineaActivaId === linea.id"
        @seleccionar="$emit('seleccionar', linea.id)"
        @eliminar="$emit('eliminar', linea.id)"
      />
      <div v-if="lineas.length === 0" class="text-sm text-color-secondary p-2 text-center">
        Sin líneas registradas
      </div>
    </div>

    <!-- Controles de la línea activa -->
    <div v-if="lineaActivaData" class="border-top-1 surface-border p-2 flex-none flex flex-column gap-2">
      <!-- Selector sentido -->
      <div class="flex gap-1">
        <Button
          label="Ida"
          size="small"
          class="flex-1"
          :severity="sentidoActivo === 'ida' ? 'primary' : 'secondary'"
          :outlined="sentidoActivo !== 'ida'"
          @click="$emit('setSentido', 'ida')"
        />
        <Button
          label="Vuelta"
          size="small"
          class="flex-1"
          :severity="sentidoActivo === 'vuelta' ? 'primary' : 'secondary'"
          :outlined="sentidoActivo !== 'vuelta'"
          @click="$emit('setSentido', 'vuelta')"
        />
      </div>

      <!-- Horario del sentido activo -->
      <div>
        <div class="text-xs text-color-secondary mb-1">
          Horario ({{ sentidoActivo }})
        </div>
        <div class="flex gap-1 align-items-center">
          <InputText
            :model-value="lineaActivaData.horario?.[sentidoActivo]?.inicio"
            placeholder="06:30"
            size="small"
            class="flex-1"
            @update:model-value="$emit('actualizarHorario', sentidoActivo, 'inicio', $event)"
          />
          <span class="text-xs text-color-secondary">a</span>
          <InputText
            :model-value="lineaActivaData.horario?.[sentidoActivo]?.fin"
            placeholder="23:00"
            size="small"
            class="flex-1"
            @update:model-value="$emit('actualizarHorario', sentidoActivo, 'fin', $event)"
          />
        </div>
      </div>

      <!-- Modo de edición -->
      <div class="flex gap-1">
        <Button
          label="Paradas"
          icon="pi pi-map-marker"
          size="small"
          class="flex-1 text-xs"
          :severity="modoEdicion === 'paradas' ? 'primary' : 'secondary'"
          :outlined="modoEdicion !== 'paradas'"
          @click="$emit('setModo', 'paradas')"
        />
        <Button
          label="Trazado"
          icon="pi pi-pencil"
          size="small"
          class="flex-1 text-xs"
          :severity="modoEdicion === 'recorrido' ? 'primary' : 'secondary'"
          :outlined="modoEdicion !== 'recorrido'"
          @click="$emit('setModo', 'recorrido')"
        />
      </div>

      <!-- Acciones de trazado -->
      <div v-if="modoEdicion === 'recorrido'" class="flex gap-1">
        <Button
          label="↩ Deshacer"
          size="small"
          severity="secondary"
          outlined
          class="flex-1 text-xs"
          @click="$emit('deshacer')"
        />
        <Button
          label="Limpiar"
          size="small"
          severity="danger"
          outlined
          class="flex-1 text-xs"
          @click="$emit('limpiar')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TransporteLineaItem from './TransporteLineaItem.vue'

defineProps({
  lineas: Array,
  lineaActivaId: String,
  lineaActivaData: Object,
  sentidoActivo: { type: String, default: 'ida' },
  modoEdicion: { type: String, default: 'paradas' },
})

const emit = defineEmits([
  'agregar',
  'seleccionar',
  'eliminar',
  'setSentido',
  'setModo',
  'deshacer',
  'limpiar',
  'actualizarHorario',
])

const nuevaLinea = ref('')
const colorNueva = ref('#3388ff')

const agregar = () => {
  const num = nuevaLinea.value.trim()
  if (!num) return
  emit('agregar', { numero: num, color: colorNueva.value })
  nuevaLinea.value = ''
}
</script>
